<template lang="pug">
  div
    el-button.btn(
        id='botao-filtro-avancado'
        @click="voltar"
      )
        div.btn-container
          div.icon-container
            font-awesome-icon(icon="chevron-left", size="sm" color="white")
          h3.text-btn Cadastrar gleba
    el-card.card-container(shadow="hover")
      app-divider(
        label="Dados da gleba",
      )
      el-row
        p.instructions {{'Insira os dados e faça o upload do shapefile da área'}}
      validation-observer(ref='validation' tag='div')
        form-gleba(:gleba="gleba" :localizacoes = "localizacoes")
    div.btn-cadastro-container
      el-button(
        @click="voltar",
        name="cancelar"
        class="cancelarButton"
      ).btn-cadastro
        span
          i.fas.fa-times
          b &nbsp Cancelar

      el-button(
          type="success",
          @click="salvar",
          name="salvar"
        ).btn-cadastro
          span
            i.fas.fa-save
            b &nbsp Salvar
</template>
<script>
import { mapActions } from 'vuex'
import AppLabel from '@/components/AppLabel'
import AppDivider from '@/components/AppDivider'
import FormGleba from '../components/FormGleba.vue'
import AppNotificacao from '@/components/mixins/AppNotificacao'

export default {
  components: {
    AppLabel,
    AppDivider,
    FormGleba
  },

  mixins: [
    AppNotificacao
  ],

  data () {
    return {
      municipios: [],
      gleba: {
        idMunicipiosGleba: [],
        nome: '',
        areaTotal: null,
        areaRemanescente: null,
        nomeCartorio: '',
        idMunicipioCartorio: null,
        matricula: '',
        dataMatricula: null,
        folha: '',
        livro: '',
        latitude: '',
        longitude: ''
      },
      localizacoes: [],
      municipiosMapa: []
    }
  },

  computed: {
  },

  methods: {
    ...mapActions({
      criarGleba: 'gleba/criarGleba'
    }),
    voltar () {
      this.$router.push({
        name: 'bancoDados/gleba',
        params: {}
      })
    },
    async salvar () {
      const valido = await this.$refs.validation.validate()
      if (!valido) {
        this.showNotificacao(
          this.$messages.TIPO_WARNING,
          this.$messages.TITULO_WARNING,
          this.$messages.ERROS_ANALISE
        )
        return
      }
      if (this.localizacoes.length) {
        this.gleba.localizacao = this.localizacoes[0].geometry
      } else {
        this.gleba.localizacao = null
      }
      await this.criarGleba(this.gleba)
      this.voltar()
      this.showNotificacao(
        this.$messages.TIPO_SUCCESS,
        this.$messages.TIPO_SUCCESS,
        this.$messages.CADASTRAR_GLEBA
      )
    }
  }
}

</script>
<style>
.full-width {
  width: 100% !important;
}
.card-container {
  margin: 0px;
  margin-top: 30px;
  border-radius: 10px;
}
.instructions {
  padding-bottom: 20px;
  font-weight: bold;
  color: #606266 !important;
}
.btn-container {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  gap: 10px;
}
.btn {
  padding : 0px !important;
  border: 0px;
}
.text-btn {
  margin: 3px !important;
}
.icon-container {
  background-color: #009f61;
  padding-top : 5px;
  padding-bottom : 5px;
  padding-left: 10px;
  padding-right: 10px;
  border-radius: 5px;
}
.btn-cadastro-container {
  display: flex;
  justify-content: space-between;
  margin: 20px;
}
.btn-cadastro {
  width: 200px;
}
</style>



// WEBPACK FOOTER //
// src/screens/bancoDados/gleba/CadastroGleba.vue